import React from 'react'
import { Search } from 'components/common'


class MenuItem extends React.Component {
	setPermission = (checked, value) => {
		const {menu, changes, onStateChanged} = this.props;

		if (!menu.permission_bak) {
			menu.permission_bak = menu.permission;
		}
		if (!checked) {
			menu.permission = menu.permission - (menu.permission & value);
			if (menu.permission < 1 || value == 1) {
				menu.permission = -1;
			}
		}
		else {
			menu.permission = (menu.permission < 1 ? value : menu.permission | value);
			if (menu.permission > 1) {
				menu.permission |= 1;
			}
		}
		if (menu.permission == menu.permission_bak) {
			delete changes[menu.id];
		}
		else {
			changes[menu.id] = menu.permission;
		}
		onStateChanged();
	}

	onPermDeny = (e) => {
		const {menu, changes, onStateChanged} = this.props;

		menu.permission = e.currentTarget.checked ? 0 : -1;
		changes[menu.id] = menu.permission;
		onStateChanged();
	}

	onPermRead = (e) => {
		this.setPermission(e.currentTarget.checked, 1);
	}

	onPermEdit = (e) => {
		this.setPermission(e.currentTarget.checked, 2);
	}

	onPermDelete = (e) => {
		this.setPermission(e.currentTarget.checked, 4);
	}

	render() {
		const {menu, changes, indent, onExpand, onToggleActive} = this.props;
		const icon = !menu.image
			? <em className='la la-tools' />
			: (menu.image.indexOf('<svg') == 0 ? <em dangerouslySetInnerHTML={{__html: menu.image}} /> : <em className={menu.image} />);
		const changed = changes.hasOwnProperty(menu.id);
		const has_prm = menu.parent_id != 1 || !menu.children;
		const can_expand = menu.children || menu.actions;

		return (
			<tr className={classNames(menu.id < 0 ? 'italic' : null, changed ? 'bold' : null)} key={`${menu.id}`}>
				<td style={{ paddingLeft: `${20 + (indent * 50)}px` }}>
					<div
						className={classNames("flex-center", can_expand ? "pointer" : null, !has_prm || menu.permission > 0 ? null : (menu.permission == 0 ? "red" : "disabled"))}
						onClick={can_expand ? onExpand : null}
					>
						{can_expand &&
							<button className="btn btn-light btn-circular">
								<em className={classNames("la", menu.expanded == 1 ? "la-angle-down" : "la-angle-right")} />
							</button>
						}
						{icon}
						<span>{menu.text} - {menu.alias}</span>
					</div>
				</td>
				{has_prm
					? <>
						<td className='center'>
							<input type='checkbox' className='pointer' checked={menu.permission === 0} onChange={this.onPermDeny} />
						</td>
						<td className='center'>
							<input type='checkbox' className='pointer' checked={menu.permission > 0 && (menu.permission & 1) == 1} onChange={this.onPermRead} />
						</td>
						<td className='center'>
							<input type='checkbox' className='pointer' checked={menu.permission > 0 && (menu.permission & 2) == 2} onChange={this.onPermEdit} />
						</td>
						<td className='center'>
							<input type='checkbox' className='pointer' checked={menu.permission > 0 && (menu.permission & 4) == 4} onChange={this.onPermDelete} />
						</td>
					</>
				: <>
					<td />
					<td />
					<td />
					<td />
				</>
			}
			</tr>
		)

	}
}

export default class PermissionEditor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			menus: [],
		};
	}

	componentDidMount() {
		const { gid, uid } = this.props;
		http.get('/permissions/of.json', {gid: gid || -1, uid: uid || -1}, (response, success) => {
			if (success) {
				this.setState({ menus: response.menus });
			}
		});
	}

	onExpand(menu) {
		menu.expanded = menu.expanded === 1 ? 0 : 1;
		this.forceUpdate();
	}

	onStateChanged = () => {
		const { buttons, changes, onStateChanged } = this.props;

		buttons[0].disabled = Object.keys(changes).length === 0;
		onStateChanged && onStateChanged();
	}

	toggle(menu, active, recursive = false) {
		if (menu.match === false) {
			return;
		}
		if (changes.hasOwnProperty(menu.id) && changes[menu.id] == active) {
			delete changes[menu.id];
		}
		else if (menu.active != active) {
			// guarda o valor original
			changes[menu.id] = menu.active;
		}
		menu.active = active;

		if (recursive && menu.children) {
			menu.children.forEach((child) => {
				this.toggle(child, active, recursive);
			});
			menu.expanded = 1;
		}
	}

	onToggleActive = (menu, recursive) => {
		this.toggle(menu, menu.active == 0 ? 1 : 0, recursive);
		if (recursive && menu.children) {
			menu.expanded = 1;
		}
		this.forceUpdate();
	}

	onCheckAll = (e, checked = 1) => {
		hp.store.menus.forEach((menu) => {
			this.toggle(menu, checked, true);
		});
		this.forceUpdate();
	}

	onUnCheckAll = (e) => {
		this.onCheckAll(e, 0);
	}

	doSearch = (text) => {
		text = text.normalize();
		const search = (menus) => {
			let found = false;

			menus.forEach((menu) => {
				const found_children = menu.children && search(menu.children);

				menu.match = found_children || text.length == 0 || menu.d.includes(text);
				if (text.length > 0 && found_children) {
					menu.expanded = 1;
				}
				found = found || menu.match;
			});
			return found;
		}
		search(this.state.menus)
		this.forceUpdate()
	}

	renderMenus(menus, changes, all, indent = 0) {
		menus.forEach((menu, i) => {
			if (menu.match === false) {
				return;
			}
			all.push(
				<MenuItem key={menu.id}
					menu={menu}
					changes={changes}
					indent={indent}
					onExpand={this.onExpand.bind(this, menu)}
					//onToggleActive={this.onToggleActive.bind(this, menu, false)}
					onStateChanged={this.onStateChanged}
				/>
			);
			if (menu.expanded === 0) {
				return;
			}
			if (menu.children) {
				this.renderMenus(menu.children, changes, all, indent + 1);
			}
		});
	}

	render() {
		const { changes } = this.props;
		const menus = [];

		this.renderMenus(this.state.menus, changes, menus);
		return (
			<>
				<table className="table alternate sticky">
					<thead>
						<tr>
							<th>
								<div className="flex">
									<span>Menu / Opção</span>
									<Search className="ml-1 input-sm search" doSearch={this.doSearch} />
								</div>
							</th>
							<th>{__('permissions_set_negate')}</th>
							<th>{__('permissions_set_view')}</th>
							<th>{__('permissions_set_edit')}</th>
							<th>{__('permissions_set_delete')}</th>
						</tr>
					</thead>
					<tbody>
						{menus}
					</tbody>
				</table>
			</>
		)
	}
}
